export default __webpack_public_path__ + "static/media/panel-material.bac2c553.svg";